import React, { useState, useEffect } from 'react';
import './AIGenerateModal.css';
import { TypewriterText } from './TypewriterText';
import { generateArticle, generateStory } from '../api/ai';

const TEXT_SPEED = 30;

export const AIGenerateModal = ({
  type,
  show,
  onClose,
  onGenerate,
  onPartialGenerate,
}) => {
  const [prompt, setPrompt] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [doneGenerating, setDoneGenerating] = useState(false);
  const [generatedContent, setGeneratedContent] = useState(null);
  const [error, setError] = useState(null);
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  useEffect(() => {
    if (!show) {
      setIsGenerating(false);
      setDoneGenerating(false);
      setPrompt('');
      setGeneratedContent(null);
      setError(null);
      setIsTypingComplete(false);
    }
  }, [show]);

  const handleGenerate = () => {
    setIsGenerating(true);
    setError(null);
    if (type === 'article') {
      generateArticle(prompt)
        .then((response) => {
          setGeneratedContent({
            title: response.title,
            content: response.body,
            tokens: response.tokens,
            price: response.price,
            remaining_completions: response.remaining_completions,
          });
          setIsGenerating(false);
        })
        .catch((error) => {
          let errorMessage = 'Ocurrió un error al generar el contenido';
          if (error.error) {
            errorMessage = error.error;
          } else if (error.status === 403) {
            errorMessage =
              'No te quedan suficientes compleciones en la suscripción';
          }
          setError(errorMessage);
          setIsGenerating(false);
          setDoneGenerating(false);
        });
    } else if (type === 'story') {
      generateStory(prompt)
      .then((response) => {
        console.log('reponse from generateStory', response);
        setGeneratedContent({
          title: response.title,
          content: response.content || response.body || '',
          tokens: response.tokens,
          price: response.price,
          remaining_completions: response.remaining_completions,
        });
        setIsGenerating(false);
      })
      .catch((error) => {
        let errorMessage = 'Ocurrió un error al generar el contenido';
        if (error.error) {
          errorMessage = error.error;
        } else if (error.status === 403) {
          errorMessage =
            'No te quedan suficientes compleciones en la suscripción';
        }
        setError(errorMessage);
        setIsGenerating(false);
        setDoneGenerating(false);
      });
    }
  };

  const handleTypingComplete = () => {
    if (!isTypingComplete) {
      onGenerate(generatedContent);
      setIsGenerating(false);
      setDoneGenerating(true);
      setIsTypingComplete(true);
      // onClose();
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div
        className="modal ai-generate-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Generar con AI</h2>
        </div>
        <div className="modal-body">
          <div className="prompt-input">
            <label>Describí sobre qué tema querés generar:</label>
            <textarea
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder="Escribí acá..."
              rows={4}
              disabled={isGenerating}
            />
            {isGenerating && !error && (
              <div className="generating-animation">
                <div className="dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <p>Generando contenido...</p>
              </div>
            )}
            {error && (
              <div className="error-message">
                <p>{error}</p>
              </div>
            )}
            {doneGenerating && (
              <div>
                <p>Tokens usados: {generatedContent?.tokens}</p>
                <p>Precio estimado: ~{generatedContent?.price} USD</p>
                <p>
                  Compleciones restantes en suscripción:{' '}
                  {generatedContent?.remaining_completions}
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="modal-buttons">
          <button
            className="button button-grey"
            onClick={onClose}
            disabled={isGenerating || (generatedContent && !isTypingComplete)}
          >
            {doneGenerating ? 'Cerrar' : 'Cancelar'}
          </button>
          {!doneGenerating && (
            <button
              className="button button-green"
              onClick={handleGenerate}
              disabled={
                !prompt.trim() ||
                isGenerating ||
                (generatedContent && !isTypingComplete)
              }
            >
              {isGenerating && !error ? 'Generando...' : 'Generar'}
            </button>
          )}
        </div>
      </div>
      {generatedContent && !error && !isGenerating && (
        <div style={{ display: 'none' }}>
          <TypewriterText
            text={generatedContent.title}
            onComplete={() => {}}
            speed={TEXT_SPEED}
            onPartialUpdate={(text) =>
              onPartialGenerate({ title: text, content: '' })
            }
          />
          <TypewriterText
            text={generatedContent.content}
            onComplete={handleTypingComplete}
            speed={TEXT_SPEED}
            onPartialUpdate={(text) =>
              onPartialGenerate({
                title: generatedContent.title,
                content: text,
              })
            }
          />
        </div>
      )}
    </div>
  );
};
